import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'wallboxNameByBusAddress',
  standalone: true,
})
export class WallboxNameByBusAddressPipe implements PipeTransform {
  transform(busAddress: string, wallboxDevices: { name: string; busAddress: string }[]): string {
    return wallboxDevices.find((device) => device.busAddress === busAddress).name;
  }
}
